import request from '@/utils/request'

// 手动录入列表(首页无权限)
export function enterNoAuthList(query) {
    return request({
        url: '/material/druidEnter/noAuth/queryPage',
        method: 'get',
        params: query
    })
}

// 行业动态列表
export function industryList(query) {
    return request({
        url: '/material/industry/needleNewsList',
        method: 'get',
        params: query
    })
}

// 行业动态详情
export function industryDetail(id) {
    return request({
        url: `/material/industry/needleNews/${id}`,
        method: 'get',
    })
}

// 价格列表
export function priceList(query) {
    return request({
        url: '/material/metatron/price/needlePriceList',
        method: 'get',
        params: query
    })
}

// 价格详情
export function priceDetail(query) {
    return request({
        url: `/material/metatron/price/detailsNeedlePriceList`,
        method: 'get',
        params:query
    })
}

// 研究报告列表
export function reportList(query) {
    return request({
        url: '/material/report/reportNeedleList',
        method: 'get',
        params: query
    })
}

// 研究报告详情
export function reportDetail(id) {
    return request({
        url: `/material/report/boardNeedleInfo/${id}`,
        method: 'get',
    })
}

// 技术及标准列表
export function standardList(query) {
    return request({
        url: '/material/report/needleList',
        method: 'get',
        params: query
    })
}

// 技术及标准详情
export function standardDetail(id) {
    return request({
        url: `/material/report/technicalNeedleInfo/${id}`,
        method: 'get',
    })
}

// 库存列表
export function stockList(query) {
    return request({
        url: '/material/druidEnter/needleStockList',
        method: 'get',
        params: query
    })
}

// 库存详情
export function stockDetail(query) {
    return request({
        url: `/material/druidEnter/getNeedleYieldInfo`,
        method: 'get',
        params:query
    })
}

// 开工率列表
export function rateList(query) {
    return request({
        url: '/material/druidEnter/needleRateList',
        method: 'get',
        params: query
    })
}

// 开工率详情
export function rateDetail(query) {
    return request({
        url: `/material/druidEnter/getNeedleRateInfo`,
        method: 'get',
        params:query
    })
}

// 进出口量列表
export function exitList(query) {
    return request({
        url: '/material/industry/needleExitList',
        method: 'get',
        params: query
    })
}

// 进出口量详情
export function exitDetail(id) {
    return request({
        url: `/material/industry/needleExit/${id}`,
        method: 'get',
    })
}

// 下游开工率列表
export function downRateList(query) {
    return request({
        url: '/material/druidEnter/needleDownRateList',
        method: 'get',
        params: query
    })
}

// 下游开工率详情
export function downRateDetail(query) {
    return request({
        url: `/material/druidEnter/getNeedleDownRateInfo`,
        method: 'get',
        params:query
    })
}

// 下游产品价格列表
export function downPriceList(query) {
    return request({
        url: '/material/metatron/price/needleDownPriceList',
        method: 'get',
        params: query
    })
}

// 下游产品价格详情
export function downPriceDetail(query) {
    return request({
        url: `/material/metatron/price/detailsNeedleDownPriceList`,
        method: 'get',
        params:query
    })
}

// 产量列表（按国家）
export function yieldGuoList(query) {
    return request({
        url: '/material/druidEnter/needleCountryList',
        method: 'get',
        params: query
    })
}

// 产量详情（按国家）
export function yieldGuoDetail(query) {
    return request({
        url: `/material/druidEnter/getNeedleCountryInfo`,
        method: 'get',
        params:query
    })
}

// 产量列表（按月度）
export function yieldYueList(query) {
    return request({
        url: '/material/industry/needleYieldList',
        method: 'get',
        params: query
    })
}

// 产量详情（按月度）
export function yieldYueDetail(id) {
    return request({
        url: `/material/industry/needleYield/${id}`,
        method: 'get',
    })
}

// 折线图
export function priceDetailData(query) {
    return request({
        url: `/material/metatron/detail/lineChart`,
        method: 'get',
        params:query
    })
}